var React = require('react');

function CloseIconInline (overrides) {
const props = Object.assign({}, {"viewBox":"4 5 16 15","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}, overrides);
    return React.createElement("svg",props,[React.createElement("path",{"d":"M5.636 19L18.364 6.272","key":0}),React.createElement("path",{"d":"M5.636 6l12.728 12.728","key":1})]);
}

module.exports = CloseIconInline;

CloseIconInline.default = CloseIconInline;
